// components/layout-ui/LanguageSelector.jsx
import React from "react";
import {
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Tooltip,
  useTheme,
} from "@mui/material";
import { Translate } from "@mui/icons-material";
import useLanguageMenu from "../../hooks/useLanguageMenu";
import { useTranslation } from "react-i18next";
import { yellow } from "@mui/material/colors";  // ← import yellow

export default function LanguageSelector({ collapsed }) {
  const theme = useTheme();
  const {
    anchorEl,
    open,
    openMenu,
    closeMenu,
    changeLanguage,
    currentLanguageLabel,
  } = useLanguageMenu();
const { t } = useTranslation(); // ✅ make sure this line exists!

  return (
    <>
      <ListItem disablePadding sx={{ mb: 0.5 }}>
        <Tooltip
          title={collapsed ? currentLanguageLabel : ""}
          placement="right"
          arrow
        >
          <ListItemButton
            id="language-button"
            onClick={openMenu}
            sx={{
              minHeight: 48,
              px: collapsed ? 1.5 : 3,
              borderRadius: 2,
              justifyContent: collapsed ? "center" : "flex-start",
              "&:hover": { bgcolor: theme.palette.action.hover },
              width: '100%',
            }}
          >
            <ListItemIcon
              sx={{
                color: yellow[500],
                minWidth: 0,
                mr: collapsed ? 0 : 2,
                justifyContent: "center",
              }}
            >
              <Translate />
            </ListItemIcon>
            {!collapsed && (
              <ListItemText
                primary={`${t("language")}: ${currentLanguageLabel}`}
                primaryTypographyProps={{ fontSize: 16 }}
              />
            )}
          </ListItemButton>
        </Tooltip>
      </ListItem>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={closeMenu}
        getContentAnchorEl={null}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
 PaperProps={{
         sx: {
           mt: 0.5,
           width: 200,          // ← fixed width
           minWidth: 150,       // ← optional min‑width
           maxWidth: 300,       // ← optional max‑width
         },
       }}        MenuListProps={{ 'aria-labelledby': 'language-button' }}
      >
        <MenuItem onClick={() => changeLanguage("en")}>English</MenuItem>
        <MenuItem onClick={() => changeLanguage("hi")}>हिन्दी</MenuItem>
        <MenuItem onClick={() => changeLanguage("mr")}>मराठी</MenuItem>
      </Menu>
    </>
  );
}
